<template>
  <v-row no-gutters>
    <v-col v-if="appStore.isCustomer" class="delayEl">
      <CustomerAlert />
    </v-col>
    <v-col v-else>
      <div
        id="supplier-approval-list"
        :class="{ 'page-fullscreen': pageStore.isFullScreen }"
      >
        <v-card
          tile
          :class="$vuetify.breakpoint.mdAndDown ? null : 'rounded-t-xl'"
        >
            <PageHeader>
              <template #action v-if="userData.role === 'VNDR'">
                <v-btn
                  rounded
                  color="warning"
                  class="ms-2 text-capitalize"
                  depressed
                  to="/supplier-approval"
                >
                  <v-icon small left>{{ icons.mdiPlus }}</v-icon>
                  <span>Yeni Onay Formu</span>
                </v-btn>
              </template>
            </PageHeader>

          <v-data-table
            :headers="tableColumns"
            :items="tableItems"
            :loading="tableLoading"
            :height="pageStore.tableHeight"
            loader-height="2"
            :mobile-breakpoint="100"
            fixed-header
            hide-default-footer
            :options.sync="tableOptions"
            :server-items-length="tableTotalRec"
            :disable-items-per-page="true"
            :items-per-page="20"
          >
            <!-- Load More -->
            <template slot="body.append">
              <tr v-if="loadMoreLoading">
                <td :colspan="tableColumns.length">
                  <div class="text-center" v-intersect.quiet="loadMore">
                    <v-progress-circular
                      v-if="tableItems.length > 0"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </td>
              </tr>
            </template>

            <!-- Arama Alanı -->
            <template slot="body.prepend">
              <tr class="data-table-body-search">
                <!-- ID -->
                <td class="pa-0">
                  <v-text-field
                    v-model="tableSearchID"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    clearable
                    placeholder="Ara"
                    filled
                    class="rounded-0 elevation-0"
                    hide-details
                  />
                </td>

                <!-- Durum -->
                <td class="pa-0">
                  <div class="d-flex">
                    <v-select
                      v-model="tableSearchStatu"
                      :items="formStatusList"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="Ara"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                  </div>
                </td>

                <!-- Ürün Adı -->
                <td class="pa-0">
                  <div class="d-flex">
                    <v-text-field
                      v-model="tableSearchProduct"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="Ara"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                  </div>
                </td>

                <!-- Ekleyen -->
                <td class="pa-0">
                  <div class="d-flex">
                    <v-text-field
                      v-model="tableSearchCreatedBy"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="Ara"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                  </div>
                </td>


                <!-- Oluşturma Tarihi -->
                <td class="pa-0">
                  <v-text-field
                    filled
                    disabled
                    class="rounded-0 elevation-0"
                    hide-details
                  />
                </td>

                <!-- Boş (İşlemler için) -->
                <td class="pa-0">
                  <v-text-field
                    filled
                    disabled
                    class="rounded-0 elevation-0"
                    hide-details
                  />
                </td>
              </tr>
            </template>

            <!-- ID -->
            <template #[`item.id`]="{ item }">
              <v-chip label color="chip" class="d-flex justify-center">
                <div
                  class="text-truncate text-uppercase data-table-item-type-one"
                  style="width: 40px !important"
                >
                  {{ item.id }}
                </div>
              </v-chip>
            </template>

            <!-- Durum -->
            <template #[`item.statustxt`]="{ item }">
              <v-chip
                :color="item.statustype"
                class="d-flex justify-center text-caption"
                label
                outlined
              >
                {{ item.statustxt }}
              </v-chip>
            </template>

            <!-- Ürün Adı -->
            <template #[`item.product_name`]="{ item }">
              <div class="white--text text-uppercase">
                {{ item.product_name }}
              </div>
              <div class="text-caption">
                {{ item.supplier_name }}
              </div>
            </template>

            <!-- Ekleyen -->
            <template #[`item.created_by`]="{ item }">
              <div class="white--text text-uppercase">
                {{ item.created_by }}
              </div>
              <div class="text-caption">
                {{ item.form_filler }}
              </div>
            </template>


            <!-- Oluşturma Tarihi -->
            <template #[`item.created_date`]="{ item }">
              <v-chip color="" class="d-flex justify-center" label>
                <div
                  class="text-truncate d-flex align-center data-table-item-type-one"
                  style="width: 160px !important"
                >
                  <v-icon small class="mr-2">
                    {{ icons.mdiCalendarClock }}
                  </v-icon>
                  <div class="mr-1">
                    {{ item.created_date | moment("DD.MM.YYYY") }}
                  </div>
                  <span> - {{ item.created_date | moment("HH:mm") }}</span>
                </div>
              </v-chip>
            </template>

            <!-- İşlemler -->
            <template #[`item.actions`]="{ item }">
              <div class="d-flex justify-end">
                <FormView
                  :data="item"
                  :show-approve-button="item.status === 'WAIT' && (item.showApproveButton !== undefined ? item.showApproveButton : showApproveButton)"
                  :show-cancel-button="item.status === 'WAIT' && (item.showCancelButton !== undefined ? item.showCancelButton : showCancelButton)"
                  @updated="refreshList"
                />
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { ref, watch, onMounted, onUnmounted } from "vue-demi";

// Pinia
import { useAppStore } from "@/stores/app";
import { usePageStore } from "@/stores/pageHeader";
import { useSupplierApprovalStore } from "./_store";
import { useAllergenStore } from "@/stores/allergen";

// Utils
import { postData } from "@utils";
import { useDebounceFn } from "@vueuse/core";
import { useToast } from "vue-toastification/composition";

// Components
import PageHeader from "@/components/PageHeader/Index.vue";
import FormView from "./FormView.vue";
import CustomerAlert from "@/components/CustomerAlert.vue";

// Icons
import {
  mdiFileDocument,
  mdiMagnify,
  mdiCalendarClock,
  mdiPlus,
} from "@mdi/js";

export default {
  components: {
    PageHeader,
    FormView,
    CustomerAlert,
  },
  setup() {
    const store = useSupplierApprovalStore();
    const appStore = useAppStore();
    const pageStore = usePageStore();
    const toast = useToast();
    const allergenStore = useAllergenStore();
    const userData = JSON.parse(localStorage.getItem("userData"));

    const pageSettings = () => {
      pageStore.pageTitle = "Tedarikçi Onay Formları";
      pageStore.pageIcon = mdiFileDocument;
      pageStore.hasFullScreen = false;
      pageStore.hasDownload = false;
      pageStore.hasDownloadApi = true;
      pageStore.hasDateRangeAll = true;
      pageStore.hasDateRange = true;
      pageStore.hasActions = true;
    };

    // Table
    const tableLoading = ref(true);
    const tableItems = ref([]);
    const tableTotalRec = ref(0);

    // Buton görünürlük state'leri (response seviyesinden gelecek)
    const showApproveButton = ref(false);
    const showCancelButton = ref(false);

    // Table Columns
    const tableColumns = ref([
      {
        text: "ID",
        value: "id",
        sortable: false,
        width: "90px",
      },
      {
        text: "Durum",
        value: "statustxt",
        sortable: false,
        width: "160px",
      },
      {
        text: "Ürün Adı",
        value: "product_name",
        sortable: false,
      },
      {
        text: "Ekleyen",
        value: "created_by",
        sortable: false,
      },

      {
        text: "Oluşturma Tarihi",
        value: "created_date",
        align: "right",
        sortable: false,
        width: "150px",
      },
      {
        text: "",
        value: "actions",
        sortable: false,
        width: "100px",
      },
    ]);

    // Table Load More
    const tablePage = ref(1);
    const loadMoreLoading = ref(false);
    const loadMore = (isIntersecting) => {
      if (isIntersecting) {
        tablePage.value++;
        tableOptions.value.page = tablePage.value;
        if (!tableLoading.value) {
          tableFetch();
        }
      }
    };

    // Tablo Arama
    const tableReFetch = ref(false);
    const tableSearchID = ref("");
    const tableSearchProduct = ref("");
    const tableSearchCreatedBy = ref("");
    const tableSearchStatu = ref("");

    const tableSearchPreparedDateMenu = ref(false);
    const tableSearchPreparedDate = ref("");

    const tableOptions = ref({
      page: 1,
      itemsPerPage: 15,
      sortBy: ["id"],
      sortDesc: [true],
    });

    // Form durum listesi - servisten çekilecek
    const formStatusList = ref([]);

    // Status mapping için değişken - artık kullanılmıyor, direkt servisten gelen bilgiler kullanılacak

    // Durum listesini servisten çek
    const fetchStatusList = async () => {
      try {
        const response = await postData({
          method: "vendorFormOperations",
          func: "getStatusList",
        });

        if (response && !response.error && response.data) {
          // Servisten gelen veriyi işle
          const statusList = [];
          Object.keys(response.data).forEach((key) => {
            const status = response.data[key];
            statusList.push({
              text: status.stext,
              value: key,
            });

          // Artık statustxt ve statustype doğrudan servisten geldiği için mapping kullanılmıyor
          });
          formStatusList.value = statusList;
        }
      } catch (e) {
        console.error("Durum listesi yüklenemedi:", e);
        // Fallback: Varsayılan durumlar
        formStatusList.value = [
          { text: "Onay Bekliyor", value: "WAIT" },
          { text: "Reddedildi", value: "CNC" },
          { text: "Kabul edildi", value: "APR" },
        ];
      }
    };

    const debouncedTableSearch = useDebounceFn(() => {
      tableFetch();
    }, 700);

    watch(
      [
        tableSearchID,
        tableSearchProduct,
        tableSearchCreatedBy,
        tableSearchPreparedDate,
        tableSearchStatu,
        tableReFetch,
      ],
      () => {
        loadMoreLoading.value = false;
        tableLoading.value = true;
        tablePage.value = 1;
        tableOptions.value.page = 1;
        tableItems.value = [];

        debouncedTableSearch();
      }
    );

    // Tarih aralığı için değişiklikler izleniyor
    const tableRangeDate = ref({
      start: null,
      end: null,
      text: null,
      value: "all",
    });
    watch(
      () => pageStore.dateRange,
      (newVal) => {
        tableRangeDate.value = newVal;
        loadMoreLoading.value = false;
        tableLoading.value = true;
        tablePage.value = 1;
        tableOptions.value.page = 1;
        tableItems.value = [];

        debouncedTableSearch();
      }
    );

    // API İstek
    const tableFetch = () => {
      tableLoading.value = true;
      const request = {
        method: "vendorFormOperations",
        func: "list",
        options: JSON.stringify(tableOptions.value),
      };

      if (tableRangeDate.value.value != "all") {
        request["search[startdate]"] = tableRangeDate.value.start;
        request["search[enddate]"] = tableRangeDate.value.end;
      }

      if (tableSearchID.value) {
        request["search[id]"] = tableSearchID.value;
      }
      if (tableSearchProduct.value) {
        request["search[product_name]"] = tableSearchProduct.value;
      }
      if (tableSearchCreatedBy.value) {
        request["search[created_by]"] = tableSearchCreatedBy.value;
      }
      if (tableSearchPreparedDate.value) {
        request["search[prepared_date]"] = tableSearchPreparedDate.value;
      }
      if (tableSearchStatu.value) {
        request["search[status]"] = tableSearchStatu.value;
      }

      postData(request)
        .then((response) => {
          // API dönüşündeki hatalara bakıyoruz
          if (response.error) {
            throw new Error(response.msg);
          }

          // Global buton görünürlük değerlerini varsayılan olarak true yap
          // Artık her bir item kendi showApproveButton ve showCancelButton değerlerini içeriyor
          showApproveButton.value = true;
          showCancelButton.value = true;

          // Toplam kayıt sayısı işleniyor
          tableTotalRec.value = Number(response.pagination.totalRec);

          // API'dan gelen veriler işleniyor
          if (response.result.length === 0) {
            loadMoreLoading.value = false;
            return;
          }

          // Responsedan gelen veriler işleniyor
          response.result.forEach((item) => {
            // JSON string'i parse et
            if (typeof item.allergens === 'string') {
              try {
                item.allergensData = JSON.parse(item.allergens);
              } catch (e) {
                item.allergensData = [];
              }
            }

            // Servisten gelen status ve statustxt bilgilerini doğrudan kullan
            // Eğer statustxt yoksa status değerine göre varsayılan değer ata
            if (!item.statustxt) {
              if (item.status === 'WAIT') item.statustxt = 'Onay Bekliyor';
              else if (item.status === 'CNC') item.statustxt = 'Reddedildi';
              else if (item.status === 'APR') item.statustxt = 'Kabul edildi';
              else item.statustxt = 'Bekliyor';
            }

            // Eğer statustype yoksa status değerine göre varsayılan değer ata
            if (!item.statustype) {
              if (item.status === 'WAIT') item.statustype = 'warning';
              else if (item.status === 'CNC') item.statustype = 'error';
              else if (item.status === 'APR') item.statustype = 'success';
              else item.statustype = 'warning';
            }

            tableItems.value.push(item);
          });

          loadMoreLoading.value = false;
          if (tableTotalRec.value > tableOptions.value.itemsPerPage) {
            setTimeout(() => {
              loadMoreLoading.value = true;
            }, 300);
          }
        })
        .catch((e) => {
          // API hataya girdi
          toast.error(e.message, {
            position: "bottom-center",
          });
        })
        .finally(() => {
          // API işlemi bittikten sonra
          tableLoading.value = false;
          startPage.value = false;
        });
    };

    // Search Clear
    const searchClear = () => {
      tablePage.value = 1;
      tableOptions.value.page = 1;
      tableSearchID.value = null;
      tableReFetch.value = !tableReFetch.value;
    };

    const startPage = ref(false);
    onMounted(async () => {
      pageSettings();
      startPage.value = true;

      // Durum listesini önce yükle
      await fetchStatusList();

      // Sonra tablo verisini çek
      if (!appStore.isCustomer) tableFetch();

      // Allergen verilerini yükle (tek sefer API çağrısı)
      allergenStore.fetchAllergenData();
    });

    // Onay/Reddet sonrası tabloyu temizle ve yeniden çek
    const refreshList = () => {
      loadMoreLoading.value = false;
      tableLoading.value = true;
      tablePage.value = 1;
      tableOptions.value.page = 1;
      tableItems.value = [];
      tableFetch();
    };

    onUnmounted(() => {
      pageStore.pageSettingsClear();
    });

    watch(
      () => [appStore.selectedCustomer],
      (val) => {
        if (appStore.isCustomer) return;
        if (!startPage.value) {
          loadMoreLoading.value = false;
          tableLoading.value = true;
          tablePage.value = 1;
          tableOptions.value.page = 1;
          tableItems.value = [];
          tableFetch();
        } else {
          startPage.value = false;
        }
      }
    );
    return {
      refreshList,
      // Pinia
      store,
      appStore,
      pageStore,
      userData,

      // Table
      tableFetch,
      tableColumns,
      tableItems,
      tableLoading,
      loadMore,
      loadMoreLoading,
      tableTotalRec,
      tableOptions,

      // Table Search
      tableSearchID,
      tableSearchProduct,
      tableSearchCreatedBy,
      tableSearchPreparedDateMenu,
      tableSearchPreparedDate,
      tableSearchStatu,
      formStatusList,
      showApproveButton,
      showCancelButton,

      // icons
      icons: {
        mdiFileDocument,
        mdiMagnify,
        mdiCalendarClock,
        mdiPlus
      },
    };
  },
};
</script>
